module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 279);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Link;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(3);

var _bind2 = _interopRequireDefault(_bind);

var _general = __webpack_require__(27);

var _general2 = _interopRequireDefault(_general);

var _state = __webpack_require__(28);

var _state2 = _interopRequireDefault(_state);

var _type = __webpack_require__(29);

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind2.default.bind(_extends({}, _general2.default, _state2.default, _type2.default));

/**
 * There are a variety of different link styles available to be used across the
 * product, marketing site and the blog. The optional `type` prop defines the
 * link style and the optional `hasUnderline` style adds a underline to each link.
 */
function Link(_ref) {
  var _cx;

  var alt = _ref.alt,
      block = _ref.block,
      children = _ref.children,
      download = _ref.download,
      hasUnderline = _ref.hasUnderline,
      id = _ref.id,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      onClick = _ref.onClick,
      tabIndex = _ref.tabIndex,
      target = _ref.target,
      title = _ref.title,
      type = _ref.type,
      url = _ref.url,
      dataBypass = _ref['data-bypass'];

  var linkClasses = cx('link', (_cx = {}, _defineProperty(_cx, type + '-isActive', isActive && !isDisabled), _defineProperty(_cx, type + '-hasUnderline', hasUnderline), _defineProperty(_cx, type + '-isDisabled', isDisabled), _defineProperty(_cx, type, !isActive && !isDisabled), _defineProperty(_cx, 'display-block', block), _defineProperty(_cx, 'display-inlineBlock', !block), _defineProperty(_cx, 'isDisabled', isDisabled), _cx));

  var linkProps = {
    alt: alt,
    className: linkClasses,
    id: id,
    onClick: onClick,
    title: title,
    tabIndex: tabIndex
  };
  if (dataBypass) {
    linkProps['data-bypass'] = true;
  }

  if (url) {
    return _react2.default.createElement(
      'a',
      _extends({}, linkProps, { download: download, target: target, href: url }),
      children
    );
  }
  return _react2.default.createElement(
    'span',
    linkProps,
    children
  );
}

Link.propTypes = {
  alt: _propTypes2.default.string,
  block: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  download: _propTypes2.default.bool,
  hasUnderline: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  isActive: _propTypes2.default.bool,
  isDisabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number,
  target: _propTypes2.default.oneOf(['_blank', '_parent', '_self', '_top']),
  title: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(Object.keys(_type2.default)).isRequired,
  url: _propTypes2.default.string,
  'data-bypass': _propTypes2.default.bool
};

Link.defaultProps = {
  block: false,
  download: false,
  hasUnderline: false,
  isActive: false,
  type: 'light'
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link":"general__link___2uaDd cursor-pointer textDecoration-none transitionDuration-m transitionProperty-all transitionTimingFunction-linear","isDisabled":"general__isDisabled___13hDh pointerEvents-none userSelect-none"};

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tabs = __webpack_require__(280);

Object.defineProperty(exports, 'Tabs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tabs).default;
  }
});

var _TabLink = __webpack_require__(76);

Object.defineProperty(exports, 'TabLink', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TabLink).default;
  }
});

var _TabPane = __webpack_require__(78);

Object.defineProperty(exports, 'TabPane', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TabPane).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"light-isActive":"state__light-isActive___2naAu c-marvel c-blue--d--hover","light-isDisabled":"state__light-isDisabled___3uVvv c-smoke--xd","light-hasUnderline":"state__light-hasUnderline___2COHc underline underline--smoke--xd","lightBlue-isActive":"state__lightBlue-isActive___hxX3- c-marvel c-blue--d--hover","lightBlue-isDisabled":"state__lightBlue-isDisabled___2cpBs c-smoke--xd","lightBlue-hasUnderline":"state__lightBlue-hasUnderline___UDm8k underline underline--smoke--xd","lightReversed-isActive":"state__lightReversed-isActive___1sL3h c-white c-white--hover","lightReversed-isDisabled":"state__lightReversed-isDisabled___1Bj6n c-smoke--xd","lightReversed-hasUnderline":"state__lightReversed-hasUnderline___2ayte underline underline--silver","dark-isActive":"state__dark-isActive___1sgHj c-marvel c-blue--d--hover","dark-isDisabled":"state__dark-isDisabled___18Q5n c-silver","dark-hasUnderline":"state__dark-hasUnderline___1_LJo underline underline--smoke--xd","negative-isActive":"state__negative-isActive___WKEbm c-slate c-negative--hover","negative-isDisabled":"state__negative-isDisabled___2sRV4 c-silver","negative-hasUnderline":"state__negative-hasUnderline___1BO_G underline underline--smoke--xd","blue-isActive":"state__blue-isActive___170NY c-blue c-blue--d--hover","blue-isDisabled":"state__blue-isDisabled___gG9pF c-blue opacity-70","blue-hasUnderline":"state__blue-hasUnderline___1m5Cl underline underline--marvel","green-isActive":"state__green-isActive___Vz44X c-green c-green--d--hover","green-isDisabled":"state__green-isDisabled___2AKVK c-green opacity-70","green-hasUnderline":"state__green-hasUnderline___1vQxK underline underline--green","orange-isActive":"state__orange-isActive___2UKHh c-orange c-orange--d--hover","orange-isDisabled":"state__orange-isDisabled___1AwH0 c-orange opacity-70","orange-hasUnderline":"state__orange-hasUnderline___3zfv4 underline underline--orange","teal-isActive":"state__teal-isActive___2pwQe c-teal c-teal--d--hover","teal-isDisabled":"state__teal-isDisabled___2G4QF c-teal opacity-70","teal-hasUnderline":"state__teal-hasUnderline___P7nQi underline underline--teal","purple-isActive":"state__purple-isActive___mhiwL c-purple c-purple--d--hover","purple-isDisabled":"state__purple-isDisabled___3gwaz c-purple opacity-70","purple-hasUnderline":"state__purple-hasUnderline___2oQ_O underline underline--purple","red-isActive":"state__red-isActive___3uyen c-red c-red--d--hover","red-isDisabled":"state__red-isDisabled___11j6j c-red opacity-70","red-hasUnderline":"state__red-hasUnderline___p1zDE underline underline--red","opaque-isActive":"state__opaque-isActive___2hIwr c-white opacity-100 c-white--hover","opaque-isDisabled":"state__opaque-isDisabled___HZWHM c-white opacity-40","opaque-hasUnderline":"state__opaque-hasUnderline___11xok underline underline--white--transparent","opaqueReversed-isActive":"state__opaqueReversed-isActive___WHruu c-marvel opacity-100 opacity-60--hover","opaqueReversed-isDisabled":"state__opaqueReversed-isDisabled___15RMw c-white opacity-60","opaqueReversed-hasUnderline":"state__opaqueReversed-hasUnderline___17gvm underline underline--white--transparent","snowBg-isActive":"state__snowBg-isActive___ZDNsF c-slate bg-snow--hover bg-snow--d--hover","snowBg-isDisabled":"state__snowBg-isDisabled___2gjHW c-silver","snowBg-hasUnderline":"state__snowBg-hasUnderline___25VIF underline underline--smoke--xd"};

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _TabLink = __webpack_require__(76);

var _TabLink2 = _interopRequireDefault(_TabLink);

var _TabPane = __webpack_require__(78);

var _TabPane2 = _interopRequireDefault(_TabPane);

var _general = __webpack_require__(282);

var _general2 = _interopRequireDefault(_general);

var _size = __webpack_require__(77);

var _size2 = _interopRequireDefault(_size);

var _sidebarSize = __webpack_require__(283);

var _sidebarSize2 = _interopRequireDefault(_sidebarSize);

var _utils = __webpack_require__(284);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var alignClasses = {
  left: 'textAlign-left',
  center: 'textAlign-center',
  right: 'textAlign-right'
};

var Tabs = function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedTab: null
    }, _this.handleSelect = function (tab) {
      _this.setState({
        selectedTab: tab
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tabs, [{
    key: 'render',
    value: function render() {
      var isVertical = this.props.isVertical;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)({
            'display-flex': isVertical
          })
        },
        this.renderTabLinks(),
        this.renderActivePane()
      );
    }
  }, {
    key: 'renderTabLinks',
    value: function renderTabLinks() {
      var _cx;

      var _props = this.props,
          align = _props.align,
          children = _props.children,
          isVertical = _props.isVertical,
          justified = _props.justified,
          isDisabled = _props.isDisabled,
          size = _props.size,
          sidebarSize = _props.sidebarSize;


      var selectedTab = this.getSelectedTab();
      var handleSelect = this.props.handleSelect || this.handleSelect;

      var commonProps = {
        isDisabled: isDisabled,
        isVertical: isVertical,
        handleSelect: handleSelect,
        size: size
      };

      var tabLinks = (0, _utils.filterChildren)(children, function (child) {
        return child.type === _TabLink2.default;
      });

      if (justified) {
        commonProps.width = 100 / tabLinks.length;
      }

      var tabListStyles = (0, _classnames2.default)(alignClasses[align], _sidebarSize2.default[sidebarSize], (_cx = {}, _defineProperty(_cx, _general2.default.container, !isVertical), _defineProperty(_cx, _general2.default.verticalContainer, isVertical), _cx));

      return _react2.default.createElement(
        'div',
        { className: tabListStyles },
        tabLinks.map(function (child) {
          var tabLinkProps = _extends({}, commonProps, {
            isActive: child.props.to === selectedTab
          });
          return _react2.default.cloneElement(child, tabLinkProps);
        })
      );
    }
  }, {
    key: 'renderActivePane',
    value: function renderActivePane() {
      var selectedTab = this.getSelectedTab();

      return (0, _utils.findChild)(this.props.children, function (child) {
        return child.type === _TabPane2.default && child.props.for === selectedTab;
      });
    }
  }, {
    key: 'getSelectedTab',
    value: function getSelectedTab() {
      return this.state.selectedTab || this.props.selectedTab || this.getFirstTabName();
    }
  }, {
    key: 'getFirstTabName',
    value: function getFirstTabName() {
      var firstTablink = (0, _utils.findChild)(this.props.children, function (child) {
        return child.type === _TabLink2.default;
      });
      return firstTablink.props.to;
    }
  }]);

  return Tabs;
}(_react.Component);

exports.default = Tabs;


Tabs.propTypes = {
  align: _propTypes2.default.oneOf(Object.keys(alignClasses)),
  children: _propTypes2.default.node,
  isVertical: _propTypes2.default.bool,
  isDisabled: _propTypes2.default.bool,
  justified: _propTypes2.default.bool.isRequired,
  size: _propTypes2.default.oneOf(Object.keys(_size2.default)),
  sidebarSize: _propTypes2.default.oneOf(Object.keys(_sidebarSize2.default)),
  selectedTab: _propTypes2.default.string,
  handleSelect: _propTypes2.default.func
};

Tabs.defaultProps = {
  align: 'left',
  isVertical: false,
  justified: false,
  size: 'medium',
  sidebarSize: 'auto'
};

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"general__container___1s9mj","withMargin":"general__withMargin___2-gzk","tab":"general__tab___3HUvi transitionDuration-l","verticalTab":"general__verticalTab___3V2Rj borderWidth-0 borderStyle-solid borderColor-snow--d","isActive":"general__isActive___35c0u"};

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"general__container___lLG2r borderBottomWidth-1 borderColor-smoke borderStyle-solid borderWidth-0 inline userSelect-none","verticalContainer":"general__verticalContainer___2_UcT borderBottomWidth-0 display-flex flexDirection-column borderWidth-0 inline userSelect-none"};

/***/ }),

/***/ 283:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"extraSmall":"sidebarSize__extraSmall___3yQ23 width-10","small":"sidebarSize__small____CIv0 width-20","medium":"sidebarSize__medium___pCOrC width-30","large":"sidebarSize__large___1a-Ks width-40","auto":"sidebarSize__auto___RrrUa width-auto"};

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterChildren = filterChildren;
exports.findChild = findChild;

var _find = __webpack_require__(38);

var _find2 = _interopRequireDefault(_find);

var _react = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterChildren(children, predicate) {
  return _react.Children.toArray(children).filter(predicate);
}

function findChild(children, predicate) {
  return (0, _find2.default)(_react.Children.toArray(children), predicate);
}

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"light":"type__light___37Mus c-silver c-black--hover","lightBlue":"type__lightBlue___1ONWN c-silver c-marvel--hover","lightReversed":"type__lightReversed___1IV0P c-silver c-white--hover","dark":"type__dark___3peZp c-slate c-black--hover","darkToBlue":"type__darkToBlue___3basT c-slate c-marvel--hover","licoriceToBlue":"type__licoriceToBlue___-lATf c-licorice c-marvel--hover","negative":"type__negative___24MPh c-silver c-negative--hover","negativeDark":"type__negativeDark___2Ay5p c-slate c-negative--hover","blue":"type__blue___35MPc c-blue c-blue--d--hover","green":"type__green___3gt26 c-green c-green--d--hover","orange":"type__orange___3NsXR c-orange c-orange--d--hover","teal":"type__teal___2ndI7 c-teal c-teal--d--hover","purple":"type__purple___126TX c-purple c-purple--d--hover","red":"type__red___1tbbY c-red c-red--d--hover","opaque":"type__opaque___3NJPL c-white breakPointM-opacity-60 opacity-100--hover","opaqueReversed":"type__opaqueReversed___xfBCt c-white opacity-100 opacity-60--hover","snowBg":"type__snowBg___1ziSR c-slate bg-snow--hover"};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("classnames/bind");

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

module.exports = require("lodash/find");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("lodash/noop");

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__(3);

var _bind2 = _interopRequireDefault(_bind);

var _noop = __webpack_require__(4);

var _noop2 = _interopRequireDefault(_noop);

var _Link = __webpack_require__(14);

var _Link2 = _interopRequireDefault(_Link);

var _general = __webpack_require__(281);

var _general2 = _interopRequireDefault(_general);

var _size = __webpack_require__(77);

var _size2 = _interopRequireDefault(_size);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tabSizes = Object.keys(_size2.default);
var tabStyles = _extends({}, _general2.default, _size2.default);
var cx = _bind2.default.bind(tabStyles);

var TabLink = function (_Component) {
  _inherits(TabLink, _Component);

  function TabLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TabLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabLink.__proto__ || Object.getPrototypeOf(TabLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelect = function (e) {
      _this.props.handleSelect(_this.props.to, e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TabLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isActive = _props.isActive,
          isDisabled = _props.isDisabled,
          isVertical = _props.isVertical,
          linkType = _props.linkType,
          onClick = _props.onClick,
          size = _props.size,
          width = _props.width;


      var containerProps = {
        className: cx('container', {
          withMargin: !width,
          'pointerEvents-none': isDisabled
        }),
        style: { width: width + '%' },
        onClick: this.handleSelect
      };

      var linkProps = {
        block: !!width || isVertical,
        isActive: isActive,
        onClick: onClick,
        isDisabled: isDisabled,
        type: linkType
      };

      var tabClasses = cx(size, {
        tab: !isVertical,
        verticalTab: isVertical,
        isActive: isActive && !isVertical,
        'textAlign-center': width
      });

      return _react2.default.createElement(
        'div',
        containerProps,
        _react2.default.createElement(
          _Link2.default,
          linkProps,
          _react2.default.createElement(
            'div',
            { className: tabClasses },
            children
          )
        )
      );
    }
  }]);

  return TabLink;
}(_react.Component);

exports.default = TabLink;


TabLink.propTypes = {
  children: _propTypes2.default.node.isRequired,
  /** Marked as optional to supppress React warnings. See https://github.com/facebook/react/issues/4494 */
  handleSelect: _propTypes2.default.func,
  isActive: _propTypes2.default.bool,
  isDisabled: _propTypes2.default.bool,
  isVertical: _propTypes2.default.bool,
  linkType: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired,
  size: _propTypes2.default.oneOf(tabSizes),
  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  width: _propTypes2.default.number
};

TabLink.defaultProps = {
  linkType: 'dark',
  onClick: _noop2.default,
  size: 'medium'
};

/***/ }),

/***/ 77:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"extraSmall":"size__extraSmall___jVUAS fontSize-s paddingLeftRight-xs paddingTopBottom-xs","small":"size__small___O2ADN fontSize-s paddingLeftRight-xs paddingTopBottom-s","medium":"size__medium___2ugiQ fontSize-m paddingLeftRight-s paddingTopBottom-m"};

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabPane;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TabPane(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    null,
    children
  );
}

TabPane.propTypes = {
  children: _propTypes2.default.node.isRequired
};

/***/ })

/******/ });
//# sourceMappingURL=marvel-ui-tabs.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/lib/marvel-ui-tabs.js
// module id = 1116
// module chunks = 35783957827783